import React from 'react';

import { Card, Text } from '@change/ds-core-ui/next';

import { SectionSeparator } from 'src/app/pages/petitionGamma/details/shared/components';

import { LegislativeBodyCard } from './components/LegislativeBodyCard';
import { PrimaryDecisionMaker } from './components/PrimaryDecisionMaker';
import { ViewAll } from './components/ViewAll';
import type { LegislativeBody } from './hooks/useDecisionMakers';
import { useDecisionMakers } from './hooks/useDecisionMakers';

export const LegislativeBodiesContainer: React.FC = () => {
	const {
		data: { legislativeBodies, displayViewAllButton },
	} = useDecisionMakers();

	return (
		<>
			<SectionSeparator />

			<Text variant="heading" className="mb-4">
				The Decision Makers
			</Text>
			<Text as="div" variant="body" className="mb-6">
				Decision makers are the people in positions of power—like government officials, business leaders, or school
				administrators—who have the ability to create the change you’re asking for. When you start or sign a petition,
				you’re helping show them that this issue matters.
			</Text>

			<Card className="mb-6 p-6">
				<PrimaryDecisionMaker />
			</Card>

			{legislativeBodies.map((legislativeBody: LegislativeBody) => (
				<LegislativeBodyCard key={legislativeBody.title} legislativeBody={legislativeBody} />
			))}
			{displayViewAllButton && <ViewAll />}
		</>
	);
};
